//It is better to put this array outside the main component.
export const monthsFR = [
  ["Janvier", "Janv"], //[["name","shortName"], ... ]
  ["Février", "Févr"],
  ["Mars", "Mars"],
  ["Avril", "Avr"],
  ["Mai", "Mai"],
  ["Juin", "Juin"],
  ["Juillet", "Juil"],
  ["Août", "Août"],
  ["Septembre", "Sept"],
  ["Octobre", "Oct"],
  ["Novembre", "Nov"],
  ["Décembre", "Déc"],
]
export const monthsFRLowercase = [
  ["janvier", "janv"],
  ["février", "févr"],
  ["mars", "mars"],
  ["avril", "avr"],
  ["mai", "mai"],
  ["juin", "juin"],
  ["juillet", "juil"],
  ["août", "août"],
  ["septembre", "sept"],
  ["octobre", "oct"],
  ["novembre", "nov"],
  ["décembre", "déc"],
];
export const weekDaysFR = [
  ["Dimanche", "Dim"], //[["name","shortName"], ... ]
  ["Lundi", "Lun"],
  ["Mardi", "Mar"],
  ["Mercredi", "Mer"],
  ["Jeudi", "Jeu"],
  ["Vendredi", "Ven"],
  ["Samedi", "Sam"],
];

export const monthsEN = [
  ["january", "jan"],
  ["february", "feb"],
  ["march", "mar"],
  ["april", "apr"],
  ["may", "may"],
  ["june", "jun"],
  ["july", "jul"],
  ["august", "aug"],
  ["september", "sep"],
  ["october", "oct"],
  ["november", "nov"],
  ["december", "dec"],
];

export const weekDaysEN = [
  ["saturday", "sat"],
  ["sunday", "sun"],
  ["monday", "mon"],
  ["tuesday", "tue"],
  ["wednesday", "wed"],
  ["thursday", "thu"],
  ["friday", "fri"],
];

export const monthsDE = [
  ["Januar", "jan"],
  ["Februar", "feb"],
  ["März", "mär"],
  ["April", "apr"],
  ["Mai", "mai"],
  ["Juni", "jun"],
  ["Juli", "jul"],
  ["August", "aug"],
  ["September", "sep"],
  ["Oktober", "okt"],
  ["November", "nov"],
  ["Dezember", "dez"]
];

export const weekDaysDE = [
  ["Samstag", "Sa"],
  ["Sonntag", "So"],
  ["Montag", "Mo"],
  ["Dienstag", "Di"],
  ["Mittwoch", "Mi"],
  ["Donnerstag", "Do"],
  ["Freitag", "Fr"]
];